import { TransformBoolean } from '../../../decorators/transform-boolean.decorator';
import { TransformFloat } from '../../../decorators/transform-float.decorator';
import { TransformInt } from '../../../decorators/transform-int.decorator';
import { ChargeTypeEnum } from '../../../enums/charge-type.enum';
import { PricingPresetRequirementEnum } from '../../../enums/pricing-preset-requirement.enum';
import { TaxRateTypeEnum } from '../../../enums/tax-rate-type.enum';
import { PricingItemTypeEnum } from '../../pricing-items/enums/pricing-item-type.enum';

/**
 * Vehicle category pricing item preset DTO
 */
export class VehicleCategoryPricingItemPresetDto {
  @TransformInt()
  id?: number;
  uuid!: string;
  name!: string;
  description?: string | null;
  type!: PricingItemTypeEnum;
  taxRateType!: TaxRateTypeEnum;
  @TransformFloat()
  unitPrice?: number | null;
  @TransformInt()
  sortOrder?: number | null;
  @TransformInt()
  pricingItemTemplateId?: number | null;
  hasUnits?: boolean | null;
  @TransformInt()
  maxUnits?: number | null;
  chargeType?: ChargeTypeEnum | null;
  presetRequirement?: PricingPresetRequirementEnum | null;
  @TransformBoolean()
  isStandardDiscountApplied?: boolean;
}
